/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M6.235 5.578v-4.56c0-.271.224-.5.5-.5h-.157c.27 0 .5.223.5.5v4.56h4.562c.276 0 .5.231.5.501v-.157c0 .276-.23.5-.5.5H7.079v4.56c0 .271-.224.5-.5.5h.157c-.27 0-.5-.223-.5-.5v-4.56H1.673c-.276 0-.5-.231-.5-.501v.157c0-.276.23-.5.5-.5h4.561z",
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Plus";
Svg.element = element;
export default Svg;
